import { render, staticRenderFns } from "./HeaderOfPublicTender.vue?vue&type=template&id=3ffe6d88&scoped=true&"
import script from "./HeaderOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./HeaderOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOfPublicTender.vue?vue&type=style&index=0&id=3ffe6d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe6d88",
  null
  
)

export default component.exports